import { Box, FormHelperText, Switch as MuiSwitch } from '@mui/material';
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';

const Switch = forwardRef(({ overwriteProps = {}, ...props }, ref) => {
  const { getValues } = useFormContext();
  const { isHidden, isReadOnly } = useEntityPermission();
  const { control } = useFormContext();

  const currentvalue = getValues(props?.name);

  if (isReadOnly(props?.permission, currentvalue)) {
    return (
      <ReadOnly name={props?.name}>{currentvalue ? 'Yes' : 'No'}</ReadOnly>
    );
  }

  if (isHidden(props?.permission)) {
    return <input type="hidden" name={props?.name} value={currentvalue} />;
  }

  return (
    <Controller
      name={props?.name}
      control={control}
      render={({ field, fieldState: { error: fsError } }) => {
        return (
          <Box>
            <Box>
              <MuiSwitch
                ref={ref}
                {...field}
                checked={!!field?.value}
                {...overwriteProps}
                disabled={props?.disabled || false}
              />
              <ReadOnly>{field?.value ? 'Yes' : 'No'}</ReadOnly>
            </Box>
            {Boolean(fsError?.message) && (
              <FormHelperText error={Boolean(fsError?.message)}>
                {fsError?.message}
              </FormHelperText>
            )}
          </Box>
        );
      }}
    />
  );
});

export default Switch;
